<template>
    <div class="over_layout">
        <section class="upgrade">
            <a style="cursor: pointer" @click="$store.commit('paymentModal', true)">{{ $store.getters.t('create_resume')
                }}</a>
        </section>
        <section class="setting_block">
            <div class="wrapper">
                <div class="block">
                    <div class="image_left">
                        <div class="user_img">
                            <img
                                :src="$store.getters.user.avatar ? $store.getters.user.avatar.image : $store.getters.user.photo"
                                @click="$store.commit('uploadPhoto', true)"
                            >
                        </div>
                        <div class="fields">
                            <div class="img_load">
                                <label>
                                    <div class="attach__up"></div>
                                    <input class="attach_input" type="file">
                                </label>
                            </div>
                            <div class="input_type">
                                <div class="edit_pane" @click="switchClick"></div>
                                <input
                                    class="inp_text"
                                    name="name"
                                    :class="errors.first('name') ? 'invalid' : ''"
                                    disabled
                                    :placeholder="$store.getters.t('name')"
                                    type="text"
                                    v-model="name"
                                    v-validate="'required|min:3'"
                                >
                            </div>
                            <div class="input_type">
                                <div class="edit_pane" @click="switchClick"></div>
                                <input
                                    class="inp_text"
                                    name="surname"
                                    :class="errors.first('surname') ? 'invalid' : ''"
                                    disabled
                                    :placeholder="$store.getters.t('surname')"
                                    type="text"
                                    v-model="surname"
                                    v-validate="'required|min:3'"
                                >
                            </div>
                            <div class="input_type">
                                <div
                                    v-if="!$store.getters.user.email_verified_at"
                                    class="edit_pane"
                                    @click="switchClick"
                                ></div>
                                <input
                                    class="inp_text"
                                    name="email"
                                    :class="errors.first('email') ? 'invalid' : ''"
                                    disabled
                                    :placeholder="$store.getters.t('email')"
                                    type="email"
                                    v-model="email"
                                    v-validate="'required|email'"
                                >
                            </div>
                            <div class="input_type">
                                <input
                                    class="submit change-password"
                                    type="submit"
                                    :value="$store.getters.t('change_password')"
                                    @click="$store.commit('changePassword', true)"
                                >
                            </div>
                            
                            <div class="input_type" v-if="$store.getters.is('Support') || $store.getters.is('Admin')">
                                <a
                                    class="submit change-password dashboard-button"
                                    :href="`/${$store.getters.locale}/admin`"
                                >{{ $store.getters.t('dashboard')}}</a>
                            </div>
                            <!--<div class="card_icon">-->
                            <!--<img src="/vue/images/card_icon.png">-->
                            <!--</div>-->
                            <!--<div class="input_type">-->
                            <!--<input class="submit" type="submit" value="Swich to busniess">-->
                            <!--</div>-->
                            <!--<div class="text">-->
                            <!--Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed-->
                            <!--diam nonumy eirmod tempor invidunt ut labore et dolore magna-->
                            <!--</div>-->
                        </div>
                        <div class="logout">
                            <a @click.prevent="logout()" href="#logout">{{ $store.getters.t('logout') }}</a>
                        </div>
                    </div>
                    <div class="full_info">
                        <template v-if="$store.getters.user.active_tariff.length > 0">
                            <div class="circles">
                                <div class="circle">
                                    <div class="days">{{$store.getters.user.active_tariff[0].days.d}} <span>{{ $store.getters.t('day') }}</span></div>
                                </div>
                                <div class="circle">
                                    <div class="days">{{$store.getters.user.active_tariff[0].days.h}} <span>{{ $store.getters.t('hour') }}</span></div>
                                </div>
                            </div>
                            <div class="tariff_name" :class="$store.getters.user.active_tariff[0].style"><span>{{ $store.getters.user.active_tariff[0].display_name }}</span></div>
                        </template>
                        <div class="all_title_block">
                            <div class="title_block">
                                <div></div>
                                <span>{{ $store.getters.t('Last_edited') }} </span>
                            </div>
                        </div>
                        <div class="last_resume" style="position: relative">
                            <div v-for="(cv, index) in cvs" :key="index + '-cv'">
                                <router-link
                                    :to="{
                              name: 'cv-show-' + cv.type,
                              params: {
                                lang: $store.getters.locale,
                                cv: cv.id
                              }
                            }"
                                    :title="`cv - ${cv.id}`">
                                    <img
                                        :src="cv.filename ? '/uploads/cv/'+ cv.filename +'.png': '/uploads/cv/cv_img_' + cv.id + '.png'"
                                        v-if="cv.status_generate">
                                    
                                    <div class="loader loader--style1" title="0" v-else style="margin-top: 128px;">
                                        <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg"
                                             xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                             width="100px" height="100px" viewBox="0 0 40 40" enable-background="new 0 0 40 40"
                                             xml:space="preserve">
                              <path opacity="0.2" fill="#000" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
                                s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
                                c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/>
                                            <path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
                                C22.32,8.481,24.301,9.057,26.013,10.047z">
                                <animateTransform attributeType="xml"
                                                  attributeName="transform"
                                                  type="rotate"
                                                  from="0 20 20"
                                                  to="360 20 20"
                                                  dur="0.5s"
                                                  repeatCount="indefinite"/>
                                </path>
                              </svg>
                                    </div>
                                </router-link>
                            </div>
                            <div class="add_circle_div">
                                <div class="add_circle" @click="openPaymentModal()"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <avatar-editor
            v-if="$store.getters.uploadPhoto"
            :image="$store.getters.user.photo ? $store.getters.user.photo : '/vue/images/user_img.jpg'"
            :dataUrl="'/api/user/image/change'"
        ></avatar-editor>
        <change-password v-if="$store.getters.changePassword"></change-password>
    </div>
</template>
<script>
    import AvatarEditor from "../modals/avatar-editor";
    import ChangePassword from "../modals/change-password";
    import Seo from "../../mixins/seo.js";
    
    export default {
        components: {
            AvatarEditor,
            ChangePassword
        },
        data() {
            return {
                name: this.$store.getters.user.name,
                surname: this.$store.getters.user.surname,
                email: this.$store.getters.user.email,
                cvs: []
            };
        },
        mounted() {
            this.$parent.getData().then(changed => {
                if (changed) {
                    this.getCVS();
                }
            });
        },
        methods: {
            logout() {
                NProgress.start();
                this.$http({
                    method: "get",
                    url: "/api/logout"
                }).then(res => {
                    if (res.data.success) {
                        this.$store.commit("user", '');
                        this.$router.push({
                            name: "home",
                            params: {lang: this.$store.getters.locale}
                        });
                    }
                    NProgress.done();
                });
            },
            getCVS() {
                this.$http({
                    method: "get",
                    url: "/api/cv"
                }).then(res => {
                    this.cvs = res.data.cvs;
                    let unloadCvs = this.cvs.filter(_ => _.status_generate === 0);
                    if (unloadCvs.length > 0) {
                        setTimeout(this.getCVS, 1000);
                    }
                });
            },
            switchClick(icon) {
                let parent = icon.target.parentNode;
                let input = parent.getElementsByTagName("input")[0];
                if (icon.target.classList.contains("save")) {
                    icon.target.classList.remove("save");
                    parent.classList.remove("active");
                    input.setAttribute("disabled", true);
                    let tmp = input.getAttribute("name");
                    if (!this.errors.first(tmp)) {
                        if (this[tmp].trim() != this.$store.getters.user[tmp]) {
                            NProgress.start();
                            this.$http({
                                method: "post",
                                url: "/api/user/update",
                                data: {
                                    [tmp]: this[tmp]
                                }
                            }).then(res => {
                                if (res.data.user) {
                                    this.$store.commit("user", res.data.user);
                                    this.$store.commit("newMessage", {
                                        show: true,
                                        type: "success",
                                        messageTitle: this.$store.getters.t("success"),
                                        message: "\"" + this.$store.getters.t(tmp) + "\"" + " " + this.$store.getters.t("update")
                                    });
                                } else if (res.data.errors) {
                                    this.$store.commit("newMessage", {
                                        show: true,
                                        type: "error",
                                        messageTitle: this.$store.getters.t("invalid"),
                                        message: this.$store.getters.t(tmp)
                                    });
                                }
                                NProgress.done();
                            });
                        }
                    } else {
                        this[tmp] = this.$store.getters.user[tmp];
                        this.$store.commit("newMessage", {
                            show: true,
                            type: "error",
                            messageTitle: this.$store.getters.t("invalid"),
                            message: this.$store.getters.t(tmp)
                        });
                    }
                } else {
                    icon.target.classList.add("save");
                    parent.classList.add("active");
                    input.removeAttribute("disabled");
                }
            },
            openPaymentModal() {
                this.$store.commit("paymentModal", true);
            },
        }
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/pages/profile.vue